import settings from '@/settings'

let getOfertasByCliente = (headers) => {
  return fetch(`${settings.apetrusApi}/ofertas/porcliente/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let getOfertasByClienteCombustivel = (id, headers) => {
  return fetch(`${settings.apetrusApi}/ofertas/porcliente/?id_combustivel=${id}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserir = (oferta, headers) => {
  return fetch(`${settings.apetrusApi}/ofertas/cadastrar/`, {
    method: 'post',
    body: JSON.stringify(oferta),
    mode: 'cors',
    headers: headers
  })
}

let cancelar = (idOferta, corpo, headers) => {
  return fetch(`${settings.apetrusApi}/ofertas/cancelar/?id=${idOferta}`, {
    method: 'delete',
    body: JSON.stringify(corpo),
    mode: 'cors',
    headers: headers
  })
}

const gerenciar = (headers, data) => {
  // métodos suportados POST, GET, PUT, PATCH, DELETE
  let url = `${settings.apetrusApi}/ofertas/viewset/${data.id ? `${data.id}/` : ''}`

  const request = {
    method: data.method,
    mode: 'cors',
    headers: headers
  }

  if (data.parametros) {
    Object.keys(data.parametros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
    })
  }

  if (data.method === 'GET') {
    request.cache = 'default'
  } else request.body = JSON.stringify(data.body)

  return fetch(url, request)
}

let verificarPadrao = (headers, data) => {
  let url = `${settings.apetrusApi}/ofertas/verificar-padrao/`
  if (data) {
    Object.keys(data).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    cache: 'default',
    mode: 'cors',
    headers: headers
  })
}

export default {
  getOfertasByCliente,
  getOfertasByClienteCombustivel,
  inserir,
  cancelar,
  gerenciar,
  verificarPadrao
}
